import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent {
  @Input('tabTitle') title!: string;
  @Input('url') url!: string;
  @Input() activeTabName!: string;
}
